export default {
    no_reservation_message:
        'Nažalost, nismo pronašli rezervacije za Vaše izabrane filtere ili nemate trenutno nijednu aktivnu rezervaciju.',
    no_timeline_reservation_message: 'Nažalost, nismo pronašli rezervacije za odabrani datum.',
    reservation_number: '🚀 Broj rezervacija: {n}',
}
